export default "__VITE_ASSET__90687ff0__$_?react__"